import request from "./http";
import qs from 'qs'

// 	 * 根据所有ip的最新数据
export function getNewAllByIp() {
    return request({
        url: "/computer/getNewAllByIp",
        method: "get",
    });
}
// 	 * 根据ip查询该ip的最新信息
export function getComputerUsageByIp(params) {
    return request({
        url: "/computer/getComputerUsageByIp",
        method: "get",
        params
    });
}
// 	 * 隐患自查保存版本
export function verifyditSave(params) {
    return request({
        url: "/verifydit/save",
        method: "POST",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}
// 	 * 隐患自查 查询版本所有名称
export function getVersionsName() {
    return request({
        url: "/verifydit/getVersionsName",
        method: "POST",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
    });
}
// 	 * 隐患自查 根据版本名称查询历史
export function getDayaByVersionsName(params) {
    return request({
        url: "/verifydit/getDayaByVersionsName",
        method: "POST",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
        },
        data:params
    });
}
// 	 * 隐患自查存量保存版本
export function ditclassSave(params) {
    return request({
        url: "/ditclass/save",
        method: "POST",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}
// 	 * 隐患自查 查询存量版本所有名称
export function ditclassgetVersionsName() {
    return request({
        url: "/ditclass/getVersionsName",
        method: "POST",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
    });
}
// 	 * 隐患自查 根据存量版本名称查询历史
export function ditclassgetDayaByVersionsName(params) {
    return request({
        url: "/ditclass/getDayaByVersionsName",
        method: "POST",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
        },
        data:params
    });
}

// 	 * 隐患自查 根据版本名称删除
export function deleteDayaByVersionsName(params) {
    return request({
        url: "/verifydit/deleteDayaByVersionsName",
        method: "POST",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
        },
        data:params
    });
}
// 	 * 隐患自查 根据存量版本名称删除
export function ditclassdeleteDayaByVersionsName(params) {
    return request({
        url: "/ditclass/deleteDayaByVersionsName",
        method: "POST",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
        },
        data:params
    });
}

 

// 	 * 应用类型->获取所有应用类型列表信息
export function findAllAppType() {
    return request({
        url: "/apptype/findAllAppType",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
    });
}


//应用类型->新增-修改应用类型
// 
export function apptypeSave(params) {
    return request({
        url: "/apptype/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
 
    });
}

//能源->根据类型编号删除应用类型
// 
export function apptypeDeleteById(params) {
    return request({
        url: "/apptype/deleteById",
        method: "delete",
        params
    });
}



// 	 * 应用类型组->获取应用类型组及应用类型树
export function findAppTypeTree() {
    return request({
        url: "/apptype/findAppTypeTree",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
    });
}

// 	  应用类型->获取未分配组的应用类型列表
export function findAllAppTypeByGroupIsNull() {
    return request({
        url: "/apptype/findAllAppTypeByGroupIsNull",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
    });
}

//应用类型->新增-修改应用类型组
// 
export function apptypeGroupSave(params) {
    return request({
        url: "/apptype/group/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
 
    });
}

//应用类型组->删除应用类型组
// 
export function apptypeGroupDeleteById(params) {
    return request({
        url: "/apptype/group/deleteGroupById",
        method: "delete",
        params
    });
}

//应用类型组->添加应用类型到组
// 
export function addAppTypeToGroup(params) {
    return request({
        url: "/apptype/group/addAppTypeToGroup",
        method: "put",
        params
    });
}

//应用类型组->从组移除应用类型
// 
export function removAppTypeToGroup(params) {
    return request({
        url: "/apptype/group/removAppTypeToGroup",
        method: "put",
        params
    });
}


//应用类型组->排序位置上下移动
// 
export function moveLocation(params) {
    return request({
        url: "/apptype/group/moveLocation",
        method: "put",
        params
    });
}

